/* EasySell post-order hook: verified in its public storefront bundle, 15 Oct 2026.
   Configure EasySell custom redirect to /pages/thank-you?order={{order.id}}.
   Order details stay in this browser tab for at most 30 minutes, never in a URL. */
(() => {
  const key = 'shapely.confirmed-order.v1';
  const ttl = 30 * 60 * 1000;
  const clean = value => String(value ?? '').slice(0, 600);
  const priorHook = window.es_hook_before_redirect;
  window.es_hook_before_redirect = async function(order) {
    // Do not interrupt the app's redirect if storage is disabled or data unavailable.
    try {
      sessionStorage.removeItem(key);
      if (order && order.id && Array.isArray(order.line_items) && order.total_price != null) {
        const a = order.shipping_address || {};
        const c = order.customer || {};
        const data = {
          id: clean(order.id), name:clean(order.name || order.order_number), created:Date.now(),
          customer:clean(a.name || [a.first_name || c.first_name, a.last_name || c.last_name].filter(Boolean).join(' ')),
          address:[a.address1,a.address2,a.city,a.province,a.zip,a.country].filter(Boolean).map(clean).join('، '),
          phone:clean(a.phone), total:clean(order.total_price), currency:clean(order.currency || 'JOD'),
          items:order.line_items.map(x=>({title:clean(x.title || x.name),variant:clean(x.variant_title),quantity:clean(x.quantity)}))
        };
        sessionStorage.setItem(key,JSON.stringify(data));
      }
    } catch (_) { /* Keep native checkout operational. */ }
    if (typeof priorHook === 'function') return priorHook.apply(this, arguments);
  };
  const root = document.querySelector('[data-thank-page]');
  if (!root) return;
  try {
    const data = JSON.parse(sessionStorage.getItem(key) || 'null');
    const reference = new URLSearchParams(location.search).get('order');
    if (!data || data.id !== reference || Date.now()-data.created > ttl || Date.now()<data.created) {
      if (data && Date.now()-data.created > ttl) sessionStorage.removeItem(key);
      return;
    }
    const text = (selector,value) => {root.querySelector(selector).textContent=value;};
    text('[data-order-id]', 'طلب رقم '+data.name);
    text('[data-order-customer]',data.customer);
    text('[data-order-address]',data.address || 'راجعي عنوان التوصيل مع فريقنا عبر واتساب.');
    text('[data-order-phone]',data.phone);
    const amount=Number(data.total);
    text('[data-order-total]',Number.isFinite(amount)?new Intl.NumberFormat('ar-JO',{style:'currency',currency:data.currency}).format(amount):data.total);
    const list=root.querySelector('[data-order-items]');
    data.items.forEach(item=>{
      const li=document.createElement('li');
      const title=document.createElement('strong');title.textContent=item.title;
      const detail=document.createElement('span');detail.textContent=[item.variant==='Default Title'?'':item.variant,'الكمية: '+item.quantity].filter(Boolean).join(' · ');
      li.append(title,detail);list.append(li);
    });
    root.querySelector('[data-order-empty]').hidden=true;
    root.querySelector('[data-order-confirmed]').hidden=false;
    setTimeout(()=>{sessionStorage.removeItem(key);root.querySelector('[data-order-confirmed]').hidden=true;root.querySelector('[data-order-empty]').hidden=false;},Math.max(0,ttl-(Date.now()-data.created)));
  } catch (_) { /* Show support state, never a fabricated confirmation. */ }
})();
